/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../../public/upgrade/feature/pointOfSale/edit/office-location/office-location.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '../../../../../../../public/upgrade/core/geo-code.service';
import * as import7 from '../../../../../../../public/upgrade/feature/pointOfSale/point-of-sale.service';
import * as import8 from '@angular/core/src/linker/view_type';
import * as import9 from '@angular/core/src/change_detection/constants';
import * as import10 from '@angular/http/src/http';
import * as import11 from '../../../../../../../public/upgrade/core/alfred.service';
import * as import12 from '@angular/core/src/linker/component_factory';
import * as import13 from '@angular/core/src/zone/ng_zone';
import * as import14 from '../../../../../../../public/upgrade/core/geo_a2.service';
import * as import15 from '../../../../../../../public/upgrade/core/logger.service';
import * as import16 from '@ngx-translate/core/src/translate.service';
import * as import17 from '@angular/core/src/linker/view_container';
import * as import18 from '@ngx-translate/core/src/translate.pipe';
import * as import19 from '@angular/core/src/linker/query_list';
import * as import20 from '../../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import21 from '../../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import22 from '../../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import23 from '../../../../../../../public/upgrade/shared/input-container/input-container.component';
import * as import24 from '../../../../shared/input-container/input-container.component.ngfactory';
import * as import25 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import26 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import27 from '@angular/core/src/linker/element_ref';
import * as import28 from '@angular/core/src/linker/template_ref';
import * as import29 from '@angular/common/src/directives/ng_class';
import * as import30 from '@angular/common/src/directives/ng_for';
import * as import31 from '@angular/common/src/directives/ng_if';
export class Wrapper_OfficeLocationComponent {
  /*private*/ _eventHandler:Function;
  context:import0.OfficeLocationComponent;
  /*private*/ _changed:boolean;
  /*private*/ _changes:{[key: string]:any};
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  /*private*/ _expr_7:any;
  subscription0:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any) {
    this._changed = false;
    this._changes = {};
    this.context = new import0.OfficeLocationComponent(p0,p1,p2,p3,p4,p5);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
    this._expr_7 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_subject(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.subject = currValue;
      this._changes['subject'] = new import1.SimpleChange(this._expr_0,currValue);
      this._expr_0 = currValue;
    }
  }
  check_dto(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.dto = currValue;
      this._changes['dto'] = new import1.SimpleChange(this._expr_1,currValue);
      this._expr_1 = currValue;
    }
  }
  check_isEditing(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.isEditing = currValue;
      this._changes['isEditing'] = new import1.SimpleChange(this._expr_2,currValue);
      this._expr_2 = currValue;
    }
  }
  check_errors(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.errors = currValue;
      this._changes['errors'] = new import1.SimpleChange(this._expr_3,currValue);
      this._expr_3 = currValue;
    }
  }
  check_errorMessages(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.errorMessages = currValue;
      this._changes['errorMessages'] = new import1.SimpleChange(this._expr_4,currValue);
      this._expr_4 = currValue;
    }
  }
  check_posSelected(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this._changed = true;
      this.context.posSelected = currValue;
      this._changes['posSelected'] = new import1.SimpleChange(this._expr_5,currValue);
      this._expr_5 = currValue;
    }
  }
  check_isValid(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_6,currValue))) {
      this._changed = true;
      this.context.isValid = currValue;
      this._changes['isValid'] = new import1.SimpleChange(this._expr_6,currValue);
      this._expr_6 = currValue;
    }
  }
  check_errorKey(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_7,currValue))) {
      this._changed = true;
      this.context.errorKey = currValue;
      this._changes['errorKey'] = new import1.SimpleChange(this._expr_7,currValue);
      this._expr_7 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) {
      if (changed) {
        this.context.ngOnChanges(this._changes);
        this._changes = {};
      }
      if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); }
    }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.onSelect.subscribe(_eventHandler.bind(view,'onSelect'))); }
  }
}
var renderType_OfficeLocationComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_OfficeLocationComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.OfficeLocationComponent>;
  _GeoCodeService_0_3:import6.GeoCodeService;
  _OfficeLocationComponent_0_4:Wrapper_OfficeLocationComponent;
  __PointOfSaleServiceA2_0_5:import7.PointOfSaleServiceA2;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_OfficeLocationComponent_Host0,renderType_OfficeLocationComponent_Host,import8.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
  }
  get _PointOfSaleServiceA2_0_5():import7.PointOfSaleServiceA2 {
    if ((this.__PointOfSaleServiceA2_0_5 == null)) { (this.__PointOfSaleServiceA2_0_5 = new import7.PointOfSaleServiceA2(this.injectorGet(import10.Http,this.parentIndex),this.injectorGet(import11.AlfredA2Service,this.parentIndex))); }
    return this.__PointOfSaleServiceA2_0_5;
  }
  createInternal(rootSelector:string):import12.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'office-location',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_OfficeLocationComponent0(this.viewUtils,this,0,this._el_0);
    this._GeoCodeService_0_3 = new import6.GeoCodeService();
    this._OfficeLocationComponent_0_4 = new Wrapper_OfficeLocationComponent(this.injectorGet(import13.NgZone,this.parentIndex),this._GeoCodeService_0_3,this.injectorGet(import14.GeoServiceA2,this.parentIndex),this.injectorGet(import15.LoggerService,this.parentIndex),this.injectorGet(import16.TranslateService,this.parentIndex),this.compView_0.ref);
    this.compView_0.create(this._OfficeLocationComponent_0_4.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import12.ComponentRef_<any>(0,this,this._el_0,this._OfficeLocationComponent_0_4.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import6.GeoCodeService) && (0 === requestNodeIndex))) { return this._GeoCodeService_0_3; }
    if (((token === import0.OfficeLocationComponent) && (0 === requestNodeIndex))) { return this._OfficeLocationComponent_0_4.context; }
    if (((token === import7.PointOfSaleServiceA2) && (0 === requestNodeIndex))) { return this._PointOfSaleServiceA2_0_5; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._OfficeLocationComponent_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._OfficeLocationComponent_0_4.context.ngAfterViewInit(); }
      this._OfficeLocationComponent_0_4.context.ngAfterViewChecked();
    }
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._OfficeLocationComponent_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const OfficeLocationComponentNgFactory:import12.ComponentFactory<import0.OfficeLocationComponent> = new import12.ComponentFactory<import0.OfficeLocationComponent>('office-location',View_OfficeLocationComponent_Host0,import0.OfficeLocationComponent);
const styles_OfficeLocationComponent:any[] = ([] as any[]);
class View_OfficeLocationComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  /*private*/ _expr_9:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import17.ViewContainer) {
    super(View_OfficeLocationComponent1,renderType_OfficeLocationComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import1.UNINITIALIZED;
    this._expr_9 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import12.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-autocomplete-item',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_2));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_8:any = import3.inlineInterpolate(1,'',this.context.$implicit.oid,'');
    if (import3.checkBinding(throwOnChange,this._expr_8,currVal_8)) {
      this.renderer.setElementProperty(this._el_0,'value',currVal_8);
      this._expr_8 = currVal_8;
    }
    const currVal_9:any = import3.inlineInterpolate(1,'',this.context.$implicit.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_9,currVal_9)) {
      this.renderer.setText(this._text_5,currVal_9);
      this._expr_9 = currVal_9;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.itemSelected(this.context.$implicit)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_OfficeLocationComponent2 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  /*private*/ _expr_7:any;
  _pipe_translate_0:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import17.ViewContainer) {
    super(View_OfficeLocationComponent2,renderType_OfficeLocationComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_7 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import12.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','-eva-3-icon-xsm eva-3-icon-error-circle'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_7:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.parentView.context.errorKey)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_7,currVal_7))) {
      this.renderer.setText(this._text_5,currVal_7);
      this._expr_7 = currVal_7;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_OfficeLocationComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_OfficeLocationComponent,{});
export class View_OfficeLocationComponent0 extends import2.AppView<import0.OfficeLocationComponent> {
  _viewQuery_map_0:import19.QueryList<any>;
  _viewQuery_pickupCity_1:import19.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _NgClass_4_3:import20.Wrapper_NgClass;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _anchor_36:any;
  /*private*/ _vc_36:import17.ViewContainer;
  _TemplateRef_36_5:any;
  _NgFor_36_6:import21.Wrapper_NgFor;
  _text_37:any;
  _text_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _anchor_42:any;
  /*private*/ _vc_42:import17.ViewContainer;
  _TemplateRef_42_5:any;
  _NgIf_42_6:import22.Wrapper_NgIf;
  _text_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _el_47:any;
  compView_47:import2.AppView<import23.InputContainerComponent>;
  _InputContainerComponent_47_3:import24.Wrapper_InputContainerComponent;
  _text_48:any;
  _text_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _el_53:any;
  _text_54:any;
  _el_55:any;
  compView_55:import2.AppView<import23.InputContainerComponent>;
  _InputContainerComponent_55_3:import24.Wrapper_InputContainerComponent;
  _text_56:any;
  _text_57:any;
  _text_58:any;
  _el_59:any;
  _text_60:any;
  _el_61:any;
  _text_62:any;
  _el_63:any;
  _el_64:any;
  _text_65:any;
  _text_66:any;
  _text_67:any;
  _text_68:any;
  _text_69:any;
  _el_70:any;
  _text_71:any;
  _el_72:any;
  _text_73:any;
  _el_74:any;
  _text_75:any;
  _el_76:any;
  _text_77:any;
  _text_78:any;
  _text_79:any;
  _text_80:any;
  _el_81:any;
  _text_82:any;
  _el_83:any;
  _text_84:any;
  _el_85:any;
  _text_86:any;
  _el_87:any;
  _text_88:any;
  _el_89:any;
  _text_90:any;
  _el_91:any;
  _text_92:any;
  _text_93:any;
  _text_94:any;
  _text_95:any;
  _text_96:any;
  _text_97:any;
  _text_98:any;
  _text_99:any;
  _text_100:any;
  _text_101:any;
  _map_115:any;
  /*private*/ _expr_116:any;
  _pipe_translate_0:import18.TranslatePipe;
  /*private*/ _expr_118:any;
  _pipe_translate_1:import18.TranslatePipe;
  /*private*/ _expr_120:any;
  _pipe_translate_2:import18.TranslatePipe;
  /*private*/ _expr_122:any;
  _pipe_translate_3:import18.TranslatePipe;
  /*private*/ _expr_124:any;
  _pipe_translate_4:import18.TranslatePipe;
  /*private*/ _expr_126:any;
  _pipe_translate_5:import18.TranslatePipe;
  _pipe_translate_6:import18.TranslatePipe;
  _pipe_translate_7:import18.TranslatePipe;
  _pipe_translate_8:import18.TranslatePipe;
  _pipe_translate_9:import18.TranslatePipe;
  /*private*/ _expr_132:any;
  _pipe_translate_10:import18.TranslatePipe;
  /*private*/ _expr_134:any;
  /*private*/ _expr_135:any;
  _pipe_translate_11:import18.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_OfficeLocationComponent0,renderType_OfficeLocationComponent,import8.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
    this._map_115 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._expr_116 = import1.UNINITIALIZED;
    this._expr_118 = import1.UNINITIALIZED;
    this._expr_120 = import1.UNINITIALIZED;
    this._expr_122 = import1.UNINITIALIZED;
    this._expr_124 = import1.UNINITIALIZED;
    this._expr_126 = import1.UNINITIALIZED;
    this._expr_132 = import1.UNINITIALIZED;
    this._expr_134 = import1.UNINITIALIZED;
    this._expr_135 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import12.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_map_0 = new import19.QueryList<any>();
    this._viewQuery_pickupCity_1 = new import19.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-validation -lg -top-left'),(null as any));
    this._NgClass_4_3 = new import20.Wrapper_NgClass(this.parentView.injectorGet(import25.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import26.KeyValueDiffers,this.parentIndex),new import27.ElementRef(this._el_4),this.renderer);
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray4(4,'class','eva-3-row','qadata','OfficeLocation'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_8,'p',new import3.InlineArray2(2,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'',(null as any));
    this._text_15 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_16 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_17 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_4,'span',new import3.InlineArray2(2,'class','validation-msg -eva-3-mb-sm'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'',(null as any));
    this._text_20 = this.renderer.createText(this._el_4,'\n\n        ',(null as any));
    this._text_21 = this.renderer.createText(this._el_2,'\n\n        ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-md'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n            ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_22,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'\n                ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_24,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 height-pickup-location'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_26,'dsp-autocomplete',new import3.InlineArray4(4,'id','pickupCity','name','puLocation'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'\n                        ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_28,'dsp-autocomplete-empty',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'\n                            ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_30,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'',(null as any));
    this._text_34 = this.renderer.createText(this._el_30,'\n                        ',(null as any));
    this._text_35 = this.renderer.createText(this._el_28,'\n                        ',(null as any));
    this._anchor_36 = this.renderer.createTemplateAnchor(this._el_28,(null as any));
    this._vc_36 = new import17.ViewContainer(36,28,this,this._anchor_36);
    this._TemplateRef_36_5 = new import28.TemplateRef_(this,36,this._anchor_36);
    this._NgFor_36_6 = new import21.Wrapper_NgFor(this._vc_36.vcRef,this._TemplateRef_36_5,this.parentView.injectorGet(import25.IterableDiffers,this.parentIndex),this.ref);
    this._text_37 = this.renderer.createText(this._el_28,'\n                    ',(null as any));
    this._text_38 = this.renderer.createText(this._el_26,'\n                ',(null as any));
    this._text_39 = this.renderer.createText(this._el_24,'\n                ',(null as any));
    this._el_40 = import3.createRenderElement(this.renderer,this._el_24,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 padding-pickup-error'),(null as any));
    this._text_41 = this.renderer.createText(this._el_40,'\n                    ',(null as any));
    this._anchor_42 = this.renderer.createTemplateAnchor(this._el_40,(null as any));
    this._vc_42 = new import17.ViewContainer(42,40,this,this._anchor_42);
    this._TemplateRef_42_5 = new import28.TemplateRef_(this,42,this._anchor_42);
    this._NgIf_42_6 = new import22.Wrapper_NgIf(this._vc_42.vcRef,this._TemplateRef_42_5);
    this._text_43 = this.renderer.createText(this._el_40,'\n                ',(null as any));
    this._text_44 = this.renderer.createText(this._el_24,'\n                ',(null as any));
    this._el_45 = import3.createRenderElement(this.renderer,this._el_24,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 padding-pickup-type'),(null as any));
    this._text_46 = this.renderer.createText(this._el_45,'\n                    ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_45,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_47 = new import24.View_InputContainerComponent0(this.viewUtils,this,47,this._el_47);
    this._InputContainerComponent_47_3 = new import24.Wrapper_InputContainerComponent();
    this._text_48 = this.renderer.createText((null as any),'\n                    ',(null as any));
    this.compView_47.create(this._InputContainerComponent_47_3.context);
    this._text_49 = this.renderer.createText(this._el_45,'\n                    ',(null as any));
    this._text_50 = this.renderer.createText(this._el_45,'\n                    ',(null as any));
    this._text_51 = this.renderer.createText(this._el_45,'\n                ',(null as any));
    this._text_52 = this.renderer.createText(this._el_24,'\n\n                ',(null as any));
    this._el_53 = import3.createRenderElement(this.renderer,this._el_24,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_54 = this.renderer.createText(this._el_53,'\n                    ',(null as any));
    this._el_55 = import3.createRenderElement(this.renderer,this._el_53,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_55 = new import24.View_InputContainerComponent0(this.viewUtils,this,55,this._el_55);
    this._InputContainerComponent_55_3 = new import24.Wrapper_InputContainerComponent();
    this._text_56 = this.renderer.createText((null as any),'\n                    ',(null as any));
    this.compView_55.create(this._InputContainerComponent_55_3.context);
    this._text_57 = this.renderer.createText(this._el_53,'\n                ',(null as any));
    this._text_58 = this.renderer.createText(this._el_24,'\n                ',(null as any));
    this._el_59 = import3.createRenderElement(this.renderer,this._el_24,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_60 = this.renderer.createText(this._el_59,'\n                    ',(null as any));
    this._el_61 = import3.createRenderElement(this.renderer,this._el_59,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 -eva-3-pl-xlg'),(null as any));
    this._text_62 = this.renderer.createText(this._el_61,'\n                        ',(null as any));
    this._el_63 = import3.createRenderElement(this.renderer,this._el_61,'a',new import3.InlineArray4(4,'class','eva-3-btn-ghost -md','qadata','marker'),(null as any));
    this._el_64 = import3.createRenderElement(this.renderer,this._el_63,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_65 = this.renderer.createText(this._el_64,'',(null as any));
    this._text_66 = this.renderer.createText(this._el_61,'\n                    ',(null as any));
    this._text_67 = this.renderer.createText(this._el_59,'\n                ',(null as any));
    this._text_68 = this.renderer.createText(this._el_24,'\n            ',(null as any));
    this._text_69 = this.renderer.createText(this._el_22,'\n\n            ',(null as any));
    this._el_70 = import3.createRenderElement(this.renderer,this._el_22,'div',new import3.InlineArray2(2,'class','col -lg-7 -md-7 -sm-12'),(null as any));
    this._text_71 = this.renderer.createText(this._el_70,'\n                ',(null as any));
    this._el_72 = import3.createRenderElement(this.renderer,this._el_70,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_73 = this.renderer.createText(this._el_72,'\n                    ',(null as any));
    this._el_74 = import3.createRenderElement(this.renderer,this._el_72,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_75 = this.renderer.createText(this._el_74,'\n                        ',(null as any));
    this._el_76 = import3.createRenderElement(this.renderer,this._el_74,'div',new import3.InlineArray4(4,'class','map','style','width: 100%;height: 300px'),(null as any));
    this._text_77 = this.renderer.createText(this._el_74,'\n                    ',(null as any));
    this._text_78 = this.renderer.createText(this._el_72,'\n                ',(null as any));
    this._text_79 = this.renderer.createText(this._el_70,'\n            ',(null as any));
    this._text_80 = this.renderer.createText(this._el_22,'\n\n            ',(null as any));
    this._el_81 = import3.createRenderElement(this.renderer,this._el_22,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_82 = this.renderer.createText(this._el_81,'\n                ',(null as any));
    this._el_83 = import3.createRenderElement(this.renderer,this._el_81,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 -eva-3-pl-xlg -eva-3-mt-md'),(null as any));
    this._text_84 = this.renderer.createText(this._el_83,'\n                    ',(null as any));
    this._el_85 = import3.createRenderElement(this.renderer,this._el_83,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_86 = this.renderer.createText(this._el_85,'\n                        ',(null as any));
    this._el_87 = import3.createRenderElement(this.renderer,this._el_85,'div',new import3.InlineArray2(2,'class','col -lg-5 -md-12 -sm-12'),(null as any));
    this._text_88 = this.renderer.createText(this._el_87,'\n                            ',(null as any));
    this._el_89 = import3.createRenderElement(this.renderer,this._el_87,'dsp-message',new import3.InlineArray4(4,'closable','false','type','warning'),(null as any));
    this._text_90 = this.renderer.createText(this._el_89,'\n                                ',(null as any));
    this._el_91 = import3.createRenderElement(this.renderer,this._el_89,'p',new import3.InlineArray2(2,'class','eva-3-p message-text -eva-3-pt-sm'),(null as any));
    this._text_92 = this.renderer.createText(this._el_91,'',(null as any));
    this._text_93 = this.renderer.createText(this._el_89,'\n                            ',(null as any));
    this._text_94 = this.renderer.createText(this._el_87,'\n                        ',(null as any));
    this._text_95 = this.renderer.createText(this._el_85,'\n                    ',(null as any));
    this._text_96 = this.renderer.createText(this._el_83,'\n                ',(null as any));
    this._text_97 = this.renderer.createText(this._el_81,'\n            ',(null as any));
    this._text_98 = this.renderer.createText(this._el_22,'\n        ',(null as any));
    this._text_99 = this.renderer.createText(this._el_2,'\n\n    ',(null as any));
    this._text_100 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_101 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_translate_0 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_28,new import3.InlineArray2(2,'search',(null as any)),this.eventHandler(this.handleEvent_28));
    this._pipe_translate_3 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_5 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_47,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_47));
    this._InputContainerComponent_47_3.subscribe(this,this.eventHandler(this.handleEvent_47),false,false,true);
    this._pipe_translate_6 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_7 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_55,new import3.InlineArray4(4,'modelChange',(null as any),'focus',(null as any)),this.eventHandler(this.handleEvent_55));
    this._InputContainerComponent_55_3.subscribe(this,this.eventHandler(this.handleEvent_55),false,false,true);
    this._pipe_translate_8 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_9 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_63,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_63));
    this._pipe_translate_10 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_11 = new import18.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._viewQuery_map_0.reset([new import27.ElementRef(this._el_76)]);
    this.context.gmapElement = this._viewQuery_map_0.first;
    this._viewQuery_pickupCity_1.reset([new import27.ElementRef(this._el_28)]);
    this.context.autocomplete = this._viewQuery_pickupCity_1.first;
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._text_34,
      this._text_35,
      this._anchor_36,
      this._text_37,
      this._text_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._anchor_42,
      this._text_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._text_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._el_55,
      this._text_56,
      this._text_57,
      this._text_58,
      this._el_59,
      this._text_60,
      this._el_61,
      this._text_62,
      this._el_63,
      this._el_64,
      this._text_65,
      this._text_66,
      this._text_67,
      this._text_68,
      this._text_69,
      this._el_70,
      this._text_71,
      this._el_72,
      this._text_73,
      this._el_74,
      this._text_75,
      this._el_76,
      this._text_77,
      this._text_78,
      this._text_79,
      this._text_80,
      this._el_81,
      this._text_82,
      this._el_83,
      this._text_84,
      this._el_85,
      this._text_86,
      this._el_87,
      this._text_88,
      this._el_89,
      this._text_90,
      this._el_91,
      this._text_92,
      this._text_93,
      this._text_94,
      this._text_95,
      this._text_96,
      this._text_97,
      this._text_98,
      this._text_99,
      this._text_100,
      this._text_101
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.NgClass) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 20)))) { return this._NgClass_4_3.context; }
    if (((token === import28.TemplateRef) && (36 === requestNodeIndex))) { return this._TemplateRef_36_5; }
    if (((token === import30.NgFor) && (36 === requestNodeIndex))) { return this._NgFor_36_6.context; }
    if (((token === import28.TemplateRef) && (42 === requestNodeIndex))) { return this._TemplateRef_42_5; }
    if (((token === import31.NgIf) && (42 === requestNodeIndex))) { return this._NgIf_42_6.context; }
    if (((token === import23.InputContainerComponent) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 48)))) { return this._InputContainerComponent_47_3.context; }
    if (((token === import23.InputContainerComponent) && ((55 <= requestNodeIndex) && (requestNodeIndex <= 56)))) { return this._InputContainerComponent_55_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_4_0_0:any = 'eva-3-validation -lg -top-left';
    this._NgClass_4_3.check_klass(currVal_4_0_0,throwOnChange,false);
    const currVal_4_0_1:any = this._map_115(!!this.context.errors['posLocation']);
    this._NgClass_4_3.check_ngClass(currVal_4_0_1,throwOnChange,false);
    this._NgClass_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_36_0_0:any = this.context.locations;
    this._NgFor_36_6.check_ngForOf(currVal_36_0_0,throwOnChange,false);
    this._NgFor_36_6.ngDoCheck(this,this._anchor_36,throwOnChange);
    const currVal_42_0_0:any = this.context.showError;
    this._NgIf_42_6.check_ngIf(currVal_42_0_0,throwOnChange,false);
    this._NgIf_42_6.ngDoCheck(this,this._anchor_42,throwOnChange);
    valUnwrapper.reset();
    const currVal_47_0_0:any = valUnwrapper.unwrap(this._pipe_translate_6.transform('pointOfSale.DESTINATION_TYPE_PLACEHOLDER'));
    this._InputContainerComponent_47_3.check_placeholder(currVal_47_0_0,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_47_0_1:any = 'destinationType';
    this._InputContainerComponent_47_3.check_name(currVal_47_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_47_0_2:any = valUnwrapper.unwrap(this._pipe_translate_7.transform('pointOfSale.DESTINATION_TYPE'));
    this._InputContainerComponent_47_3.check_label(currVal_47_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_47_0_3:any = false;
    this._InputContainerComponent_47_3.check_invalid(currVal_47_0_3,throwOnChange,false);
    const currVal_47_0_4:any = true;
    this._InputContainerComponent_47_3.check_disabled(currVal_47_0_4,throwOnChange,false);
    const currVal_47_0_5:any = this.context.dto.destinationTypeValue;
    this._InputContainerComponent_47_3.check_model(currVal_47_0_5,throwOnChange,false);
    this._InputContainerComponent_47_3.ngDoCheck(this,this._el_47,throwOnChange);
    valUnwrapper.reset();
    const currVal_55_0_0:any = valUnwrapper.unwrap(this._pipe_translate_8.transform('pointOfSale.ADDRESS_PLACEHOLDER'));
    this._InputContainerComponent_55_3.check_placeholder(currVal_55_0_0,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_55_0_1:any = 'street';
    this._InputContainerComponent_55_3.check_name(currVal_55_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_55_0_2:any = valUnwrapper.unwrap(this._pipe_translate_9.transform('pointOfSale.ADDRESS'));
    this._InputContainerComponent_55_3.check_label(currVal_55_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_55_0_3:any = false;
    this._InputContainerComponent_55_3.check_invalid(currVal_55_0_3,throwOnChange,false);
    const currVal_55_0_4:any = (this.context.dto.destinationType != 'CITY');
    this._InputContainerComponent_55_3.check_disabled(currVal_55_0_4,throwOnChange,false);
    const currVal_55_0_5:any = this.context.dto.street;
    this._InputContainerComponent_55_3.check_model(currVal_55_0_5,throwOnChange,false);
    this._InputContainerComponent_55_3.ngDoCheck(this,this._el_55,throwOnChange);
    this._vc_36.detectChangesInNestedViews(throwOnChange);
    this._vc_42.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_116:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pointOfSale.LOCATION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_116,currVal_116))) {
      this.renderer.setText(this._text_11,currVal_116);
      this._expr_116 = currVal_116;
    }
    valUnwrapper.reset();
    const currVal_118:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('pickupPoint.LOCATION_INFORMATION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_118,currVal_118))) {
      this.renderer.setText(this._text_14,currVal_118);
      this._expr_118 = currVal_118;
    }
    valUnwrapper.reset();
    const currVal_120:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform(this.context.errorMessages['posLocation'])),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_120,currVal_120))) {
      this.renderer.setText(this._text_19,currVal_120);
      this._expr_120 = currVal_120;
    }
    valUnwrapper.reset();
    const currVal_122:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('pointOfSale.CITY_AIRPORT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_122,currVal_122))) {
      this.renderer.setElementProperty(this._el_28,'label',currVal_122);
      this._expr_122 = currVal_122;
    }
    valUnwrapper.reset();
    const currVal_124:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('bookingList.filter.PICKUP_CITY.PLACEHOLDER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_124,currVal_124))) {
      this.renderer.setElementProperty(this._el_28,'placeholder',currVal_124);
      this._expr_124 = currVal_124;
    }
    valUnwrapper.reset();
    const currVal_126:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_5.transform('common.SEARCH')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_126,currVal_126))) {
      this.renderer.setText(this._text_33,currVal_126);
      this._expr_126 = currVal_126;
    }
    valUnwrapper.reset();
    const currVal_132:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_10.transform('pointOfSale.MAP_IT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_132,currVal_132))) {
      this.renderer.setText(this._text_65,currVal_132);
      this._expr_132 = currVal_132;
    }
    const currVal_134:boolean = !this.context.warningOn;
    if (import3.checkBinding(throwOnChange,this._expr_134,currVal_134)) {
      this.renderer.setElementProperty(this._el_85,'hidden',currVal_134);
      this._expr_134 = currVal_134;
    }
    valUnwrapper.reset();
    const currVal_135:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_11.transform('pointOfSale.ADDRESS_WARNING')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_135,currVal_135))) {
      this.renderer.setText(this._text_92,currVal_135);
      this._expr_135 = currVal_135;
    }
    this.compView_47.internalDetectChanges(throwOnChange);
    this.compView_55.internalDetectChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._InputContainerComponent_47_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._InputContainerComponent_55_3.context.ngAfterViewInit(); }
    }
  }
  destroyInternal():void {
    this._vc_36.destroyNestedViews();
    this._vc_42.destroyNestedViews();
    this.compView_47.destroy();
    this.compView_55.destroy();
    this._InputContainerComponent_47_3.ngOnDestroy();
    this._InputContainerComponent_55_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 36)) { return new View_OfficeLocationComponent1(this.viewUtils,this,36,this._anchor_36,this._vc_36); }
    if ((nodeIndex == 42)) { return new View_OfficeLocationComponent2(this.viewUtils,this,42,this._anchor_42,this._vc_42); }
    return (null as any);
  }
  handleEvent_28(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'search')) {
      const pd_sub_0:any = ((<any>this.context.searchLocations($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_47(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.dto.destinationTypeValue = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_55(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.dto.street = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'focus')) {
      const pd_sub_1:any = ((<any>this.context.setWarning()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_63(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.addMapMarker()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pointOfSale/edit/office-location/office-location.component.ngfactory.ts